/* ConfigureAuditScreenComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ConfigureAuditScreenRenderer");
const ScheduleVeilComponent = require("../../../../../lib/actions/veils/schedule/ScheduleVeilComponent");
// const Registrations = require("../../../../../../RegistrationNamespaces");
const _ = require("lodash");

class ConfigureAuditScreenComponent extends EventEmitter {
    constructor(
        logger,
        GameEditor,
        DeviceEntity,
        modalUserFeedback,
        userSession,
        policyIds,
        deviceId,
        ConfigAuditPolicy,
        runAll,
        ActiveView
    ) {
        super();
        this._logger = logger;
        this._gameEditor = GameEditor;
        this._configAuditPolicy = ConfigAuditPolicy;
        this._deviceEntity = DeviceEntity;
        this._activeView = ActiveView;
        this._modalUserFeedback = modalUserFeedback;
        this._policyIds = policyIds;
        this._deviceId = deviceId;

        this._userSession = userSession;
        this._workId = undefined;
        this._labelValues = undefined;
        this._isCaptureSnapshotActive = false;
        this._runAll = runAll || false;
        /* change to 
            "auditRunLevel1",
            "auditRunLevel2",
            "auditRunLevel3"
        */
        this._runPermLevels = ["auditRunLevel1", "auditRunLevel2", "auditRunLevel3"];
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._isCaptureSnapshotActive = undefined;
                this._workId = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "ConfigureAuditScreenComponent.shutdown() error.");
            }
        );
    }

    get isCaptureSnapshotActive() {
        return this._isCaptureSnapshotActive;
    }

    set isCaptureSnapshotActive(value) {
        this.setIsCaptureSnapshotActive(value);
    }

    setIsCaptureSnapshotActive(value) {
        this._isCaptureSnapshotActive = String(value) === "true";
    }

    whenModelIsReady() {
        // return this._configAuditPolicy
        //     .loadLabelValues(this._userSession.activeOrganization.id)
        //     .then((labelValues) => {
        //         this._availableAuditRunPerms = [];
        //         this._labelValues = labelValues;
        //         return Promise.resolve();
        //     });
        return this._configAuditPolicy
            .loadConfigAuditPolicies(
                this._userSession.activeOrganization.id,
                {
                    $and: [{id: {$in: this._policyIds}}],
                },
                {_id: false, id: true, name: true, permissionLevel: true}
            )
            .then((policies) => {
                const availablePermLvls = this._runPermLevels.reduce((acc, lvl) => {
                    if (this._userSession.authorizedActions.indexOf(lvl) >= 0) {
                        acc.push(lvl);
                    }
                    return acc;
                }, []);
                let noPermPolicies = [];
                this._labelValues = policies
                    .filter((policy) => {
                        const lvl = policy.permissionLevel.substr(-1);
                        const permLevel = "auditRunLevel" + lvl;
                        if (availablePermLvls.indexOf(permLevel) >= 0) {
                            return true;
                        }
                        noPermPolicies.push(policy);
                        return false;
                    })
                    .map((policy) => {
                        return {label: policy.name, value: policy.id};
                    });

                if (this._labelValues.length <= 0) {
                    if (noPermPolicies.length > 0) {
                        const lvl = noPermPolicies[0].permissionLevel.substr(-1);
                        return Promise.reject({
                            errorMsg:
                                'User not authorized for "Run Level ' + lvl + ' Audit Policies"',
                        });
                    }
                    return Promise.reject({
                        errorMsg: "User not authorized for Running Audit Policies",
                    });
                }

                return Promise.resolve(noPermPolicies);
            });
    }

    cancelAction(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _scheduleConfigAuditWork(selection, workInput) {
        // if (typeof workInput.policyId === "undefined") {
        //     this._logger.warn(
        //         { error: { errorMsg: "Required Audit Policy not selected." } },
        //         "ConfigureAuditScreenComponent._startConfigAuditWork() - Error"
        //     );
        //     return this._modalUserFeedback.displayError({
        //         errorMsg: "Required Audit Policy not selected.",
        //         errorCode: "ValidationError"
        //     });
        // }
        // let workTarget = this._getWorkTarget(selection);

        return this._modalUserFeedback
            .displayCustom(
                new ScheduleVeilComponent(this._logger, true, "Audit - Schedule", {
                    workType: "audit",
                    firstTime: true,
                }),
                {
                    dontHide: false,
                }
            )
            .then((scheduleDef) => {
                let schedule = scheduleDef.schedule;
                let name = workInput.auditTitle;
                let description = "";
                if (workInput.policyId) {
                    let policyName = this._labelValues.find(
                        (selectedObj) => selectedObj.value === workInput.policyId
                    );
                    description = policyName ? "Policy: " + policyName.label : "";
                }
                if (workInput.policyIds) {
                    // let policyName = this._labelValues.find(
                    //     (selectedObj) => selectedObj.value === workInput.policyId
                    // );
                    description = "Multi policy audit";
                }
                let displayName = name
                    ? name
                    : "Audit Run - " +
                      new Date().toLocaleDateString() +
                      " " +
                      new Date().toLocaleTimeString();
                let workInputSchedule = Object.assign(workInput, scheduleDef.workInput);
                workInputSchedule.description = displayName;
                if (this._runAll) {
                    return this._deviceEntity.scheduleMultiAuditWork(
                        displayName,
                        description,
                        schedule,
                        workInputSchedule
                    );
                } else {
                    return this._deviceEntity.scheduleAuditWork(
                        displayName,
                        description,
                        schedule,
                        workInputSchedule
                    );
                }
            })
            .catch((err) => {
                if (!err.userRejected) {
                    if (this._logger) {
                        this._logger.warn(
                            {
                                error: err,
                            },
                            "ConfigureAuditScreenComponent._scheduleConfigAuditWork() - Error"
                        );
                    } else {
                        console.error(err);
                    }
                    return this._modalUserFeedback.displayError(err);
                }
            });
    }

    _startConfigAuditWork(selection, workInput) {
        let targetPolicyCount = 1;

        if (this._runAll) {
            const policyIds = _.get(workInput, "policyIds");
            if (_.isArray(policyIds)) {
                targetPolicyCount = policyIds.length;
            } else {
                this._logger.warn(
                    {error: {errorMsg: "Required Audit Policies not selected."}},
                    "ConfigureAuditScreenComponent._startConfigAuditWork() - Error"
                );
                return this._modalUserFeedback.displayError({
                    errorMsg: "Required Audit Policies not selected.",
                    errorCode: "ValidationError",
                });
            }
        } else {
            if (!_.get(workInput, "policyId")) {
                this._logger.warn(
                    {error: {errorMsg: "Required Audit Policy not selected."}},
                    "ConfigureAuditScreenComponent._startConfigAuditWork() - Error"
                );
                return this._modalUserFeedback.displayError({
                    errorMsg: "Required Audit Policy not selected.",
                    errorCode: "ValidationError",
                });
            }
        }

        /**
         *
         * @param {Object} progress - progress data object
         * @param {number} progress.startTime
         * @param {number} progress.targetCount
         * @param {number} progress.successCount
         * @param {number} progress.failureCount
         * @param {string} progress.policyId
         * @param {string} progress.policyName
         * @param {string} progress.policyDescription
         */
        let aborted = false;

        const progressCB = (progress) => {
            const {workId, successCount, failureCount, targetCount} = progress;
            if (workId) {
                this._workId = workId;
            }
            let msg = "";
            if (this._runAll) {
                msg = `Succeeded ${successCount}, failed ${failureCount} of ${targetPolicyCount} audit policies`;
            } else {
                msg = `Succeeded ${successCount}, failed ${failureCount} of ${targetCount} devices`;
            }
            this._modalUserFeedback.showLoadingProgress(msg);
        };

        this._modalUserFeedback.displayLoading({
            message: "Auditing your devices...",
            showHideButton: true,
            showAbortButton: true,
            onAbort: () => {
                aborted = true;
                this._abortAuditWork();
            },
        });

        const runWorkProm = this._runAll
            ? this._deviceEntity.runMultiAuditWork(workInput, {launchAndForget: false}, progressCB)
            : this._deviceEntity.runAuditWork(workInput, {launchAndForget: false}, progressCB);
        return runWorkProm
            .then((result) => {
                if (aborted) {
                    return;
                }
                if (result.errorMsg) {
                    let err = new Error(result.errorMsg);
                    err.errorCode = "ConfigAuditError";
                    err.errorMsg = result.errorMsg;
                    throw err;
                }
                if (!this._modalUserFeedback.isStillOpen) {
                    return;
                }
                let userNotificationMessage = "";
                if (!result.summary) {
                    if (this._runAll) {
                        userNotificationMessage = `Total number of audit policies: ${targetPolicyCount}`;
                    } else {
                        userNotificationMessage = `Total number of devices: 1`;
                    }
                } else {
                    if (this._runAll) {
                        // const targetCount = _.get(result, "summary.targetCount", 0); // Always returns 0 - Replaced by targetPolicyCount
                        const successCount = _.get(result, "summary.successCount", 0);
                        const failedCount = _.get(result, "summary.failedCount", 0);
                        const deviceErrorCount = _.get(result, "summary.deviceErrorCount", 0);
                        const auditPolicyInViolationCount = _.get(
                            result,
                            "summary.deviceViolationCount",
                            0
                        ); // Must be renamed auditPolicyInViolationCount in summary.result
                        const auditPolicyNotInViolationCount =
                            successCount - auditPolicyInViolationCount;
                        const deviceInViolationCount = auditPolicyInViolationCount > 0 ? 1 : 0;
                        const totalViolationCount = _.get(result, "summary.totalViolationCount", 0);

                        userNotificationMessage = [
                            `Total audit policies: ${targetPolicyCount}`,
                            `Successfully run audit policies: ${successCount}`,
                            `Failed to run audit policies: ${failedCount}`,
                            "",
                            `Passed audit policies: ${auditPolicyNotInViolationCount}`,
                            `Failed audit policies: ${auditPolicyInViolationCount}`,
                            "",
                            `Device errors: ${deviceErrorCount}`,
                            `Devices in violation: ${deviceInViolationCount}`,
                            `Total violations: ${totalViolationCount}`,
                        ].join("\r\n");
                    } else {
                        const {
                            deviceCount,
                            deviceSuccessCount,
                            deviceErrorCount,
                            devicesInViolationCount,
                            violationCount,
                            devicesSkippedCount,
                        } = result.summary;
                        userNotificationMessage = [
                            `Total devices: ${deviceCount || 0}`,
                            `Audited devices: ${deviceSuccessCount || 0}`,
                            `Skipped Devices:${devicesSkippedCount}` || 0,
                            `Device errors: ${deviceErrorCount || 0}`,
                            "",
                            `Devices in violation: ${devicesInViolationCount || 0}`,
                            `Total violations: ${violationCount || 0}`,
                        ].join("\r\n");
                    }
                }

                return this._modalUserFeedback
                    .displayNotification(userNotificationMessage, {
                        title: "Audit Completed",
                        confirmDetails: {
                            text: "OK",
                            type: "text",
                        },
                    })
                    .then(() => {
                        this._modalUserFeedback.hideDisplayed();
                        return Promise.resolve();
                        // if (result.summary && result.summary.policyId) {
                        //     return this._gameEditor.launchAuditEditor(
                        //         {
                        //             fqn: Registrations.AUDIT_POLICY_EDITOR_VIEW_RESULTS
                        //         },
                        //         {
                        //             id: result.summary.policyId,
                        //             title: _.get(result.summary, "policyName", "")
                        //         }
                        //     );
                        // } else {
                        //     this._logger.warn(
                        //         { error: {} },
                        //         "ConfigureAuditScreenComponent._startConfigAuditWork() - No policyId received"
                        //     );
                        //     return Promise.reject();
                        // }
                    });
            })
            .catch((err) => {
                if (aborted) {
                    return;
                }
                if (err && err.closed) {
                    this._modalUserFeedback.hideDisplayed();
                    return Promise.resolve();
                }
                if (err && !err.userRejected) {
                    if (this._logger) {
                        this._logger.warn(
                            {error: err},
                            "ConfigureAuditScreenComponent._startConfigAuditWork() - Error"
                        );
                    } else {
                        console.error(err);
                    }
                    return this._modalUserFeedback.displayError(err);
                }
            });
    }

    _abortAuditWork() {
        this._configAuditPolicy.cancelWork(this._userSession._activeOrganization.id, this._workId);
        const title = "Audit Aborted";
        const msg = "Audit aborted by user";
        return this._modalUserFeedback.displayNotification(msg, {title});
    }
    /**
     * Create workTarget Object from devices component selection
     * @param {String} selection
     * @returns {Object}
     */
    _getWorkTarget(selection) {
        let workTarget;
        switch (selection) {
            case "all":
                workTarget = {
                    entityType: "Device",
                    category: "entity",
                    method: "query",
                    query: {},
                };
                break;
            case "selection":
                workTarget = {
                    category: "entity",
                    entityType: "Device",
                    method: "multi",
                    ids: [this._deviceId],
                };
                break;
            case "apply_current_filter":
                workTarget = {
                    entityType: "Device",
                    category: "entity",
                    method: "query",
                    query: !_.isEmpty(
                        _.get(this._activeView._userGridData.getBasicSearchData(), "filterQuery")
                    )
                        ? _.get(this._activeView._userGridData.getBasicSearchData(), "filterQuery")
                        : this._activeView._userGridData.getAdvancedSearchData(),
                };
                break;
        }
        return workTarget;
    }
    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ConfigureAuditScreenComponent;
